import {Button} from "@consta/uikit/Button";
import {IconAdd} from "@consta/uikit/IconAdd";
import React, {useEffect, useState} from "react";
import "../css/pageEquipage.css";
import {Sidebar} from '@consta/uikit/Sidebar';
import GridEquipageEquipageList from "./component/grid.equipage.equipageList";
import GridEquipageRepairList from "./component/grid.equipage.repairList";
import ModalEquipageNewRepair from "./component/modal.equipage.newRepair";

const PageEquipage = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isUpdate, setIsUpdate] = useState(false);
    const [summary, setSummary] = useState({total: 0, active: 0});
    const [repairStatusFilter, setRepairStatusFilter] = useState<'all' | 'active' | 'completed'>('all');

    useEffect(() => {
        document.title = 'АСПО.Контроль | Ремонты';
    }, []);

    const handleModalClose = (value: boolean) => {
        setIsModalOpen(false);
        setIsUpdate(value)
    };

    return (
        <div className="equipage-page">
            <header className="equipage-page-header">
                <div>
                    <h1>Ремонты БСИ</h1>
                    <p>Контроль неисправностей экипажей и периодов ремонта оборудования</p>
                </div>
                <div className="equipage-summary">
                    <span>Всего: <b>{summary.total}</b></span>
                    <span>В ремонте: <b>{summary.active}</b></span>
                </div>
            </header>

            <div className="equipage-toolbar">
                <div className="equipage-toolbar__hint">
                    Двойной клик по строке открывает карточку ремонта
                </div>
                <div className="equipage-toolbar__actions">
                    <div className="equipage-status-filter" aria-label="Фильтр ремонтов">
                        <button
                            type="button"
                            className={repairStatusFilter === 'all' ? 'is-active' : ''}
                            onClick={() => setRepairStatusFilter('all')}
                        >
                            Все
                        </button>
                        <button
                            type="button"
                            className={repairStatusFilter === 'active' ? 'is-active' : ''}
                            onClick={() => setRepairStatusFilter('active')}
                        >
                            Активные
                        </button>
                        <button
                            type="button"
                            className={repairStatusFilter === 'completed' ? 'is-active' : ''}
                            onClick={() => setRepairStatusFilter('completed')}
                        >
                            Завершенные
                        </button>
                    </div>
                    {localStorage.getItem('username') !== 'admin' &&
                        <Button
                            label="Добавить ремонт"
                            iconLeft={IconAdd}
                            size='s'
                            view="primary"
                            onClick={() => setIsModalOpen(true)}
                        />
                    }
                    <Button
                        size="s"
                        view="secondary"
                        label="Список экипажей"
                        width="default"
                        onClick={() => setIsSidebarOpen(true)}
                    />
                </div>
            </div>

            <GridEquipageRepairList
                isUpdate={isUpdate}
                onSummaryChange={setSummary}
                statusFilter={repairStatusFilter}
            />

            <Sidebar
                size={'1/2'}
                isOpen={isSidebarOpen}
                onClickOutside={() => setIsSidebarOpen(false)}
                onEsc={() => setIsSidebarOpen(false)}
            >
                <div className="equipage-sidebar">
                    <div className="equipage-sidebar__head">
                        <div>
                            <h2>Список экипажей</h2>
                            <p>Экипажи вашей организации</p>
                        </div>
                        <button type="button" onClick={() => setIsSidebarOpen(false)}>×</button>
                    </div>
                    <GridEquipageEquipageList/>
                </div>

            </Sidebar>
            <ModalEquipageNewRepair isOpen={isModalOpen}
                                    onClose={handleModalClose}
                                    props={null}
                                    nodeData={null}/>

        </div>
    )
}

export default PageEquipage;
